import {
  ADD_LOCAL_RESPONSABLE,
  ADJUNTAR_PROGRAMA_SEGURIDAD,
  CLEAR_DATOS_ESTABLECIMIENTOS,
  CLEAR_NUEVA_OBRA,
  DELETE_LOCAL_RESPONSABLE,
  FINALIZAR_OBRA,
  GET_DATOS_ESTABLECIMIENTOS,
  GET_DIAS_FECHA_INICIO_OBRA,
  GET_GESTION_OBRAS,
  GET_PREGUNTAS_ACTIVIDAD,
  GET_PREGUNTAS_TIPO_DE_OBRA,
  GET_TIPOS_AVISO_OBRA,
  GET_TIPOS_CONTRATISTA,
  GET_ULTIMO_FORMULARIO_CARGADO,
  GET_VISUALIZACION_FORMULARIO_CARGADO,
  GET_VISUALIZACION_ULTIMO_FORMULARIO_CARGADO,
  POST_ACTIVIDAD,
  POST_CARGA_NUEVA_OBRA,
  POST_DEMOLICION,
  POST_DEPENDENCIA_EMPLEADOR,
  POST_IDENTIFICACION_FORM,
  POST_RESPONSABLES_FORM,
  POST_TIPO_DE_OBRA,
  POST_UBICACION_FORM,
  VALIDAR_CARGA_NUEVA_OBRA,
  VISUALIZAR_CERTIFICADO_PRESENTACION
} from "../actions/obra";

const INITIAL_STATE = {
  tipoContratista: {
    loading: false,
    error: false,
    data: [],
  },
  datosEstablecimiento: {
    loading: false,
    error: false,
    data: [],
  },
  establecimientos: {
    loading: false,
    error: false,
    data: [],
  },
  postDependenciaEmpleador: {
    loading: false,
    error: false,
    data: [],
  },
  tipoDeObra: {
    loading: false,
    error: false,
    data: [],
  },
  validarCargaNuevaObra: {
    loading: false,
    error: false,
    data: [],
  },
  postTipoDeObra: {
    loading: false,
    error: false,
    data: [],
  },
  actividad: {
    loading: false,
    error: false,
    data: [],
  },
  postNuevaObra: {
    identificacion: {},
    ubicacion: {},
    tipoDeObra: [],
    actividad: {
      preguntas: [],
    },
    demolicion: {},
    responsables: {},
  },
  gestionDeObra: {
    loading: false,
    error: false,
    data: []
  },
  visualizarPdfObra: {
    loading: false,
    error: false,
    data: [],
  },
  finalizarObra: {
    loading: false,
    error: false,
    data: [],
  },
  ultimoFormularioCargado: {
    loading: false,
    error: false,
    data: [],
  },
  adjuntarProgramaSeguridad: {
    loading: false,
    error: false,
    data: [],
  },
  getTiposAvisoObra: {
    loading: false,
    error: false,
    data: [],
  },
  diasFechaInicioObra: {
    loading: false,
    error: false,
    data: [],
  }
};

const obra = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case `${FINALIZAR_OBRA}_PENDING`:
      return {
        ...state,
        finalizarObra: {
          ...state.finalizarObra,
          error: false,
          loading: true,
        },
      };
    case `${FINALIZAR_OBRA}_REJECTED`:
      return {
        ...state,
        finalizarObra: {
          ...state.finalizarObra,
          error: true,
          loading: false,
        },
      };
    case `${FINALIZAR_OBRA}_FULFILLED`:
      return {
        ...state,
        finalizarObra: {
          ...state.finalizarObra,
          error: false,
          loading: false,
          data: action.payload.data,
        },
      };
    case `${GET_DIAS_FECHA_INICIO_OBRA}_PENDING`:
      return {
        ...state,
        diasFechaInicioObra: {
          ...state.diasFechaInicioObra,
          error: false,
          loading: true,
        },
      };
    case `${GET_DIAS_FECHA_INICIO_OBRA}_REJECTED`:
      return {
        ...state,
        diasFechaInicioObra: {
          ...state.diasFechaInicioObra,
          error: true,
          loading: false,
        },
      };
    case `${GET_DIAS_FECHA_INICIO_OBRA}_FULFILLED`:
      return {
        ...state,
        diasFechaInicioObra: {
          ...state.diasFechaInicioObra,
          error: false,
          loading: false,
          data: action.payload.data ? parseInt(action.payload.data) : null,
        },
      };
    case `${GET_TIPOS_AVISO_OBRA}_PENDING`:
      return {
        ...state,
        getTiposAvisoObra: {
          ...state.getTiposAvisoObra,
          error: false,
          loading: true,
        },
      };
    case `${GET_TIPOS_AVISO_OBRA}_REJECTED`:
      return {
        ...state,
        getTiposAvisoObra: {
          ...state.getTiposAvisoObra,
          error: true,
          loading: false,
        },
      };
    case `${GET_TIPOS_AVISO_OBRA}_FULFILLED`:
      return {
        ...state,
        getTiposAvisoObra: {
          ...state.getTiposAvisoObra,
          error: false,
          loading: false,
          data: action.payload.data,
        },
      };
    case `${GET_GESTION_OBRAS}_PENDING`:
      return {
        ...state,
        gestionDeObra: {
          ...state.gestionDeObra,
          error: false,
          loading: true,
        },
      };
    case `${GET_GESTION_OBRAS}_REJECTED`:
      return {
        ...state,
        gestionDeObra: {
          ...state.gestionDeObra,
          error: true,
          loading: false,
        },
      };
    case `${GET_GESTION_OBRAS}_FULFILLED`:
      let data = action.payload.data;
      if (action?.meta.idGestionObra && state.gestionDeObra.data.length > 0) {
        let indexGestionDeObra = state.gestionDeObra.data.findIndex((gestion) => gestion.idGestionObra === action.meta.idGestionObra);
        if (indexGestionDeObra !== -1) {
          data = [...state.gestionDeObra.data];
          data[indexGestionDeObra] = action.payload.data[0];
        }
      }
      return {
        ...state,
        gestionDeObra: {
          ...state.gestionDeObra,
          error: false,
          loading: false,
          data,
        },
      };
    case `${GET_VISUALIZACION_ULTIMO_FORMULARIO_CARGADO}_PENDING`:
      return {
        ...state,
        visualizarPdfObra: {
          ...state.visualizarPdfObra,
          error: false,
          loading: true,
        },
      };
    case `${GET_VISUALIZACION_ULTIMO_FORMULARIO_CARGADO}_REJECTED`:
      return {
        ...state,
        visualizarPdfObra: {
          ...state.visualizarPdfObra,
          error: true,
          loading: false,
        },
      };
    case `${GET_VISUALIZACION_ULTIMO_FORMULARIO_CARGADO}_FULFILLED`:
      return {
        ...state,
        visualizarPdfObra: {
          ...state.visualizarPdfObra,
          error: false,
          loading: false,
          data: action.payload.data,
        },
      };
    case `${VISUALIZAR_CERTIFICADO_PRESENTACION}_PENDING`:
      return {
        ...state,
        visualizarPdfObra: {
          ...state.visualizarPdfObra,
          error: false,
          loading: true,
        },
      };
    case `${VISUALIZAR_CERTIFICADO_PRESENTACION}_REJECTED`:
      return {
        ...state,
        visualizarPdfObra: {
          ...state.visualizarPdfObra,
          error: true,
          loading: false,
        },
      };
    case `${VISUALIZAR_CERTIFICADO_PRESENTACION}_FULFILLED`:
      return {
        ...state,
        visualizarPdfObra: {
          ...state.visualizarPdfObra,
          error: false,
          loading: false,
          data: action.payload.data,
        },
      };
    case `${GET_VISUALIZACION_FORMULARIO_CARGADO}_PENDING`:
      return {
        ...state,
        visualizarPdfObra: {
          ...state.visualizarPdfObra,
          error: false,
          loading: true,
        },
      };
    case `${GET_VISUALIZACION_FORMULARIO_CARGADO}_REJECTED`:
      return {
        ...state,
        visualizarPdfObra: {
          ...state.visualizarPdfObra,
          error: true,
          loading: false,
        },
      };
    case `${GET_VISUALIZACION_FORMULARIO_CARGADO}_FULFILLED`:
      return {
        ...state,
        visualizarPdfObra: {
          ...state.visualizarPdfObra,
          error: false,
          loading: false,
          data: action.payload.data,
        },
      };

    case `${GET_ULTIMO_FORMULARIO_CARGADO}_PENDING`:
      return {
        ...state,
        ultimoFormularioCargado: {
          ...state.ultimoFormularioCargado,
          error: false,
          loading: true,
        },
      };
    case `${GET_ULTIMO_FORMULARIO_CARGADO}_REJECTED`:
      return {
        ...state,
        ultimoFormularioCargado: {
          ...state.ultimoFormularioCargado,
          error: true,
          loading: false,
        },
      };
    case `${GET_ULTIMO_FORMULARIO_CARGADO}_FULFILLED`:
      return {
        ...state,
        ultimoFormularioCargado: {
          ...state.ultimoFormularioCargado,
          error: false,
          loading: false,
          data: action.payload.data,
        },
      };
    case `${GET_TIPOS_CONTRATISTA}_PENDING`:
      return {
        ...state,
        tipoContratista: {
          ...state.tipoContratista,
          error: false,
          loading: true,
        },
      };
    case `${GET_TIPOS_CONTRATISTA}_REJECTED`:
      return {
        ...state,
        tipoContratista: {
          ...state.tipoContratista,
          error: true,
          loading: false,
        },
      };
    case `${GET_TIPOS_CONTRATISTA}_FULFILLED`:
      return {
        ...state,
        tipoContratista: {
          ...state.tipoContratista,
          error: false,
          loading: false,
          data: action.payload.data,
        },
      };
    case `${GET_DATOS_ESTABLECIMIENTOS}_PENDING`:
      return {
        ...state,
        datosEstablecimiento: {
          ...state.datosEstablecimiento,
          error: false,
          loading: true,
        },
      };
    case `${GET_DATOS_ESTABLECIMIENTOS}_REJECTED`:
      return {
        ...state,
        datosEstablecimiento: {
          ...state.datosEstablecimiento,
          error: true,
          loading: false,
        },
      };
    case `${GET_DATOS_ESTABLECIMIENTOS}_FULFILLED`:
      return {
        ...state,
        datosEstablecimiento: {
          ...state.datosEstablecimiento,
          error: false,
          loading: false,
          data: action.payload.data,
        },
      };
    case `${GET_PREGUNTAS_TIPO_DE_OBRA}_PENDING`:
      return {
        ...state,
        tipoDeObra: {
          ...state.tipoDeObra,
          error: false,
          loading: true,
        },
      };
    case `${GET_PREGUNTAS_TIPO_DE_OBRA}_REJECTED`:
      return {
        ...state,
        tipoDeObra: {
          ...state.tipoDeObra,
          error: true,
          loading: false,
        },
      };
    case `${GET_PREGUNTAS_TIPO_DE_OBRA}_FULFILLED`:
      return {
        ...state,
        tipoDeObra: {
          ...state.tipoDeObra,
          error: false,
          loading: false,
          data: action.payload.data,
        },
      };
    case `${POST_DEPENDENCIA_EMPLEADOR}_PENDING`:
      return {
        ...state,
        postDependenciaEmpleador: {
          ...state.postDependenciaEmpleador,
          error: false,
          loading: true,
        },
      };
    case `${POST_DEPENDENCIA_EMPLEADOR}_REJECTED`:
      return {
        ...state,
        postDependenciaEmpleador: {
          ...state.postDependenciaEmpleador,
          error: true,
          loading: false,
        },
      };
    case `${POST_DEPENDENCIA_EMPLEADOR}_FULFILLED`:
      return {
        ...state,
        postDependenciaEmpleador: {
          ...state.postDependenciaEmpleador,
          error: false,
          loading: false,
          data: action.payload.data,
        },
      };
    case `${GET_PREGUNTAS_ACTIVIDAD}_PENDING`:
      return {
        ...state,
        actividad: {
          ...state.actividad,
          error: false,
          loading: true,
        },
      };
    case `${GET_PREGUNTAS_ACTIVIDAD}_REJECTED`:
      return {
        ...state,
        actividad: {
          ...state.actividad,
          error: true,
          loading: false,
        },
      };
    case `${GET_PREGUNTAS_ACTIVIDAD}_FULFILLED`:
      return {
        ...state,
        actividad: {
          ...state.actividad,
          error: false,
          loading: false,
          data: action.payload.data,
        },
      };
    case POST_IDENTIFICACION_FORM:
      return {
        ...state,
        postNuevaObra: {
          ...state.postNuevaObra,
          identificacion: action.payload,
        },
      };
    case POST_UBICACION_FORM:
      return {
        ...state,
        postNuevaObra: {
          ...state.postNuevaObra,
          ubicacion: action.payload,
        },
      };
    case POST_DEMOLICION:
      return {
        ...state,
        postNuevaObra: {
          ...state.postNuevaObra,
          demolicion: action.payload,
        },
      };
    case POST_RESPONSABLES_FORM:
      return {
        ...state,
        postNuevaObra: {
          ...state.postNuevaObra,
          responsables: action.payload,
        },
      };
    case ADD_LOCAL_RESPONSABLE:
      return {
        ...state,
        postNuevaObra: {
          ...state.postNuevaObra,
          responsables: [...state.postNuevaObra.responsables, action.payload],
        },
      };
    case DELETE_LOCAL_RESPONSABLE:
      const deleteResponsable = state.postNuevaObra.responsables;
      const newArrayResponsables = deleteResponsable.filter(
        (g) => g.cuit !== action.payload
      );

      return {
        ...state,
        postNuevaObra: {
          ...state.postNuevaObra,
          responsables: [...newArrayResponsables],
        },
      };

    case POST_TIPO_DE_OBRA:
      const indexToUpdate = state.postNuevaObra.tipoDeObra.findIndex(
        (element) =>
          element.idGrupoItemFormularioArt ===
          action.payload.idGrupoItemFormularioArt
      );

      // Copia de preguntas para no modificar directamente el estado
      let preguntas = [...state.postNuevaObra.tipoDeObra];

      if (indexToUpdate !== -1) {
        preguntas[indexToUpdate] = action.payload;
      } else {
        preguntas.push(action.payload);
      }

      return {
        ...state,
        postNuevaObra: {
          ...state.postNuevaObra,
          tipoDeObra: preguntas,
        },
      };
    case POST_ACTIVIDAD:
      const indexToUpdateActividad =
        state.postNuevaObra.actividad.preguntas.findIndex(
          (element) =>
            element.idGrupoItemFormularioArt ===
            action.payload.idGrupoItemFormularioArt
        );

      // Copia de preguntas para no modificar directamente el estado
      let preguntasActividad = [...state.postNuevaObra.actividad.preguntas];

      if (indexToUpdateActividad !== -1) {
        preguntasActividad[indexToUpdateActividad] = action.payload;
      } else {
        preguntasActividad.push(action.payload);
      }

      return {
        ...state,
        postNuevaObra: {
          ...state.postNuevaObra,
          actividad: {
            preguntas: preguntasActividad,
          },
        },
      };
    case `${ADJUNTAR_PROGRAMA_SEGURIDAD}_PENDING`:
      return {
        ...state,
        adjuntarProgramaSeguridad: {
          ...state.adjuntarProgramaSeguridad,
          error: false,
          loading: true,
        },
      };
    case `${ADJUNTAR_PROGRAMA_SEGURIDAD}_REJECTED`:
      return {
        ...state,
        adjuntarProgramaSeguridad: {
          ...state.adjuntarProgramaSeguridad,
          error: true,
          loading: false,
        },
      };
    case `${ADJUNTAR_PROGRAMA_SEGURIDAD}_FULFILLED`:
      return {
        ...state,
        adjuntarProgramaSeguridad: {
          ...state.adjuntarProgramaSeguridad,
          error: false,
          loading: false,
          data: action.payload.data,
        },
      };
    case `${POST_CARGA_NUEVA_OBRA}_PENDING`:
      return {
        ...state,
        postTipoDeObra: {
          ...state.postTipoDeObra,
          error: false,
          loading: true,
        },
      };
    case `${POST_CARGA_NUEVA_OBRA}_REJECTED`:
      return {
        ...state,
        postTipoDeObra: {
          ...state.postTipoDeObra,
          error: true,
          loading: false,
        },
      };
    case `${POST_CARGA_NUEVA_OBRA}_FULFILLED`:
      return {
        ...state,
        postTipoDeObra: {
          ...state.postTipoDeObra,
          error: false,
          loading: false,
          data: action.payload.data,
        },
      };
    case `${VALIDAR_CARGA_NUEVA_OBRA}_PENDING`:
      return {
        ...state,
        validarCargaNuevaObra: {
          ...state.validarCargaNuevaObra,
          error: false,
          loading: true,
        },
      };
    case `${VALIDAR_CARGA_NUEVA_OBRA}_REJECTED`:
      return {
        ...state,
        validarCargaNuevaObra: {
          ...state.validarCargaNuevaObra,
          error: true,
          loading: false,
        },
      };
    case `${VALIDAR_CARGA_NUEVA_OBRA}_FULFILLED`:
      return {
        ...state,
        validarCargaNuevaObra: {
          ...state.validarCargaNuevaObra,
          error: false,
          loading: false,
          data: action.payload.data,
        },
      };
    case CLEAR_DATOS_ESTABLECIMIENTOS:
      return {
        ...state,
        datosEstablecimiento: INITIAL_STATE.datosEstablecimiento,
      };
    case CLEAR_NUEVA_OBRA:
      return {
        ...state,
        postNuevaObra: INITIAL_STATE.postNuevaObra,
        datosEstablecimiento: INITIAL_STATE.datosEstablecimiento,
        establecimientos: INITIAL_STATE.establecimientos,
      };
    default:
      return state;
  }
};

export default obra;
